"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxTypes;
(function (TaxTypes) {
    TaxTypes["VAT"] = "VAT";
    TaxTypes["NOVA_TOTAL"] = "NOVA_TOTAL";
    TaxTypes["FRT"] = "FRT";
    TaxTypes["GVT"] = "GVT";
    TaxTypes["GST"] = "GST";
    TaxTypes["HANDLING_FEE"] = "HANDLING_FEE";
    TaxTypes["LESS_FRT"] = "LESS_FRT";
    TaxTypes["LICENSE_FEE"] = "LICENSE_FEE";
    TaxTypes["LICENSE_PLATE"] = "LICENSE_PLATE";
    TaxTypes["REGISTRATION_FEE"] = "REGISTRATION_FEE";
    TaxTypes["TAVAF"] = "TAVAF";
    TaxTypes["_AGGREGATE_FEE"] = "_AGGREGATE_FEE";
    TaxTypes["DELIVERY_FEE"] = "DELIVERY_FEE";
    TaxTypes["DEALER_DELIVERY_FEE"] = "DEALER_DELIVERY_FEE";
    TaxTypes["DEALER_DELIVERY_CHARGE"] = "DEALER_DELIVERY_CHARGE";
    TaxTypes["VEHICLE_TAX"] = "VEHICLE_TAX";
    TaxTypes["LUXURY_CAR_TAX"] = "LUXURY_CAR_TAX";
    TaxTypes["STAMP_DUTY"] = "STAMP_DUTY";
    TaxTypes["HYBRID_DISCOUNT"] = "HYBRID_DISCOUNT";
    TaxTypes["RECORDING_FEE"] = "RECORDING_FEE";
    TaxTypes["ADMINISTRATION_FEE"] = "ADMINISTRATION_FEE";
    TaxTypes["REGISTRATION_PLATES"] = "REGISTRATION_PLATES";
    TaxTypes["GENERAL_ISSUE_NAMEPLATE_FEE"] = "GENERAL_ISSUE_NAMEPLATE_FEE";
    TaxTypes["TAC_AMOUNT"] = "TAC_AMOUNT";
    TaxTypes["ELECTRIC_VEHICLE_CONCESSION"] = "ELECTRIC_VEHICLE_CONCESSION";
    TaxTypes["TRAFFIC_IMPROVEMENT_FEE"] = "TRAFFIC_IMPROVEMENT_FEE";
    TaxTypes["CTP_AMOUNT"] = "CTP_AMOUNT";
    TaxTypes["TIO_AMOUNT"] = "TIO_AMOUNT";
    TaxTypes["PRESCRIBED_FLAT_FEE"] = "PRESCRIBED_FLAT_FEE";
    TaxTypes["LIFETIME_SUPPORT_FUND"] = "LIFETIME_SUPPORT_FUND";
    TaxTypes["EMERGENCY_SERVICES_LEVY"] = "EMERGENCY_SERVICES_LEVY";
    TaxTypes["ROAD_SAFETY_LEVY"] = "ROAD_SAFETY_LEVY";
    TaxTypes["MOTOR_TAX"] = "MOTOR_TAX";
    TaxTypes["FIRE_LEVY"] = "FIRE_LEVY";
    TaxTypes["MAIB_AMOUNT"] = "MAIB_AMOUNT";
    TaxTypes["VIC_ROADS_INSPECTION_FEE"] = "VIC_ROADS_INSPECTION_FEE";
    TaxTypes["VIC_ROADS_ONLINE_ADMIN_FEE"] = "VIC_ROADS_ONLINE_ADMIN_FEE";
    TaxTypes["CIRCULATION_PERMIT"] = "CIRCULATION_PERMIT";
    TaxTypes["MANDATORY_INSURANCE"] = "MANDATORY_INSURANCE";
    TaxTypes["REGISTRATION_TAX"] = "REGISTRATION_TAX";
    TaxTypes["PROCESSING_COST"] = "PROCESSING_COST";
    TaxTypes["GREEN_TAX"] = "GREEN_TAX";
    TaxTypes["TAG_CHARGE"] = "TAG_CHARGE";
    TaxTypes["TAG_RETURN_CHARGE"] = "TAG_RETURN_CHARGE";
    TaxTypes["FORUM_REGISTRATION_CHARGE"] = "FORUM_REGISTRATION_CHARGE";
    TaxTypes["AUTHORIZED_COURTESY_CHARGE"] = "AUTHORIZED_COURTESY_CHARGE";
    TaxTypes["ALL_RISK_INSURANCE"] = "ALL_RISK_INSURANCE";
})(TaxTypes = exports.TaxTypes || (exports.TaxTypes = {}));
